<template>
<div style="background: #eaeaea;">
  <div style="">
    <img src="../assets/images/media_banner.png" style="width: 100%;height: 350px;">
  </div>
  <div class="content column">
    <div class="title">
      <p>MEDIA COOPERATION <span style="color: #619A37;">合作</span>媒体</p>
      <div class="line"></div>
    </div>
    <div style="padding: 0 56px;">
      <div class="content-list">
        <div class="content-item row">
          <div style="width: 116px;height: 37px;">
            <img style="width: 100%;" src="../assets/images/media1.png" />
          </div>
          <div>
            <p>电动车时代网</p>
            <p>www.evtimes.cn</p>
          </div>
        </div>
        <div class="content-item row">
          <div style="width: 116px;height: 37px;">
            <img style="width: 100%;" src="../assets/images/media1.png" />
          </div>
          <div>
            <p>电动车时代网</p>
            <p>www.evtimes.cn</p>
          </div>
        </div>
        <div class="content-item row">
          <div style="width: 116px;height: 37px;">
            <img style="width: 100%;" src="../assets/images/media1.png" />
          </div>
          <div>
            <p>电动车时代网</p>
            <p>www.evtimes.cn</p>
          </div>
        </div>
      </div>
      <div class="content-list">
        <div class="content-item row">
          <div style="width: 116px;height: 37px;">
            <img style="width: 100%;" src="../assets/images/media1.png" />
          </div>
          <div>
            <p>电动车时代网</p>
            <p>www.evtimes.cn</p>
          </div>
        </div>
        <div class="content-item row">
          <div style="width: 116px;height: 37px;">
            <img style="width: 100%;" src="../assets/images/media1.png" />
          </div>
          <div>
            <p>电动车时代网</p>
            <p>www.evtimes.cn</p>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>
</template>

<script>
import { getArticleCategory } from '@/http/api'
export default {
  data() {
    return {
      articleList: []
    };
  },

  methods: {
  },
  created() {
  }
};
</script>
<style lang="less" scoped>
.title {
  background: #eaeaea;
  font-size: 28px;
  padding-top: 20px;
}
.title p {
  font-weight: 600;
}
.line {
  width: 30px;
  height: 2px;
  background: #619A37;
  margin-top: 20px;
  margin-bottom: 40px;
}
.content {
  width: 1200px;
  margin: 0 auto;  
  display: flex;
  padding-bottom: 30px;
  background-color: #ffffff;
}

.content-list {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-top: 56px;
  border-bottom: 1px solid #dddddd;
}
.content-item {
  width: 33%;
  box-sizing: border-box;
  padding-bottom: 22px;
}
.content-item p {
  font-size: 14px;
  font-family: FZLanTingHei-R-GBK;
  font-weight: 400;
  color: #444444;
  padding-left: 14px;
}

</style>



// WEBPACK FOOTER //
// src/view/commedia.vue